import { render, staticRenderFns } from "./MtipocanalcmncGrid.vue?vue&type=template&id=38e0b445"
import script from "./MtipocanalcmncGrid.vue?vue&type=script&lang=js"
export * from "./MtipocanalcmncGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports